import { AppState } from '../index';
import { IFormSection } from 'core/models';

export const activityTemplateSelector = ({ formTemplateState }: AppState): IFormSection[] =>
  formTemplateState?.activityTemplate;

export const activityValidationObjectSelector = ({ formTemplateState }: AppState): unknown =>
  formTemplateState?.activityValidationObject;
